import { alignVariantMetadataToLength } from "./alignVariantMetadataToLength";
import type { ComponentStoreData, VariantMetadata } from "./types";

/**
 * Merges metadata keys at a variant index, padding/truncating so metadata stays aligned
 * with that component's values. Does not change `components`.
 *
 * @param store - Current component store
 * @param componentName - Component being edited
 * @param index - Variant index
 * @param patch - Metadata keys to merge at that index
 * @returns Next store snapshot
 */
export const applyVariantMetadataPatch = (
  store: ComponentStoreData,
  componentName: string,
  index: number,
  patch: VariantMetadata
): ComponentStoreData => {
  const prevComponents = store.components ?? {};
  const prevMetadata = store.variantMetadata ?? {};
  const currentValues = prevComponents[componentName] || [];
  const nextMetadata = alignVariantMetadataToLength(prevMetadata[componentName], currentValues.length);
  nextMetadata[index] = { ...nextMetadata[index], ...patch };

  return {
    ...store,
    variantMetadata: { ...prevMetadata, [componentName]: nextMetadata },
  };
};
